import CalendarMonth from '@mui/icons-material/CalendarMonth'
import Chair from '@mui/icons-material/Chair'
import VideoCameraFront from '@mui/icons-material/VideoCameraFront'
import { FormControl, MenuItem, Select } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { SIREN_ICON_ID, VISIT_EVENT_TYPES } from 'src/consumer/constants'
import {
  formatEventFeeLabel,
  getMeetingSrcIcon,
} from 'src/consumer/helpers/meetingSrcUtils'
import { getImageLink, getSubscriptionPlanById } from 'src/mentor/helpers/utilityFunctions'
import { getInitiallySelectedEventTypeData } from '../../ClinicManageBookingsHelper'
import {
  getDefaultOrFirstEmergencyEventData,
  getDefaultOrFirstFollowUpEventData,
  getDefaultOrFirstInPersonEventData as getDefaultOrFirstRegularInPersonEventData,
  getDefaultOrFirstRegularConsultationOrTherapyVideoEventData as getDefaultOrFirstRegularVideoEventData,
} from '../utils'
import {
  CHOSEN_BLOCK_EMERGENCY_IN_PERSON,
  CHOSEN_BLOCK_FOLLOW_UP_IN_PERSON,
  CHOSEN_BLOCK_IN_PERSON,
  CHOSEN_BLOCK_VIDEO,
  getChosenBlocksBasedOnDefaultSelectedItem,
} from './utils'

export const EventSelectorForBooking = ({
  selectedEventTypeId,
  eventTypesVisible,
  setSelectedEventTypeId,
  clinicLocationId,
  mentorProfileData,
  selectedVisitType,
  setSelectedVisitType,
  useClinicServices = false,
}) => {
  const defaultEventTypeData = useMemo(() => {
    return getInitiallySelectedEventTypeData(eventTypesVisible, clinicLocationId, useClinicServices)
  }, [eventTypesVisible, clinicLocationId, useClinicServices])
  const [, setChosenBlockId] = useState()
  const inPersonBlock = useMemo(() => {
    return getDefaultOrFirstRegularInPersonEventData({
      defaultEventTypeData: defaultEventTypeData,
      eventTypesForOtherSessionsDropdown: eventTypesVisible,
    })
  }, [defaultEventTypeData, eventTypesVisible])
  const videoBlock = useMemo(() => {
    return getDefaultOrFirstRegularVideoEventData({
      defaultEventTypeData: defaultEventTypeData,
      eventTypesForOtherSessionsDropdown: eventTypesVisible,
    })
  }, [defaultEventTypeData, eventTypesVisible])
  const emergencyBlock = useMemo(() => {
    return getDefaultOrFirstEmergencyEventData({
      defaultEventTypeData: defaultEventTypeData,
      eventTypesForOtherSessionsDropdown: eventTypesVisible,
    })
  }, [defaultEventTypeData, eventTypesVisible])
  const followUpBlock = useMemo(() => {
    return getDefaultOrFirstFollowUpEventData({
      defaultEventTypeData: defaultEventTypeData,
      eventTypesForOtherSessionsDropdown: eventTypesVisible,
    })
  }, [defaultEventTypeData, eventTypesVisible])

  const [otherOptionsArray, setOtherOptionsArray] = useState([])
  const [subscriptionPlansById, setSubscriptionPlansById] = useState({})

  const isOtherSelected = (otherOptionsArray?.map((eve) => eve?.uid) || []).includes(
    selectedEventTypeId,
  )
  const linkedSubscriptionPlanIds = useMemo(
    () =>
      [
        ...new Set(
          (eventTypesVisible || [])
            .map((eventType) => eventType?.subscriptionPlanId || eventType?.pricingPlanId)
            .filter(Boolean),
        ),
      ],
    [eventTypesVisible],
  )

  useEffect(() => {
    const planIdsToFetch = linkedSubscriptionPlanIds.filter(
      (planId) => !Object.prototype.hasOwnProperty.call(subscriptionPlansById, planId),
    )

    if (planIdsToFetch.length === 0) {
      return undefined
    }

    let isMounted = true
    Promise.all(
      planIdsToFetch.map(async (planId) => {
        try {
          const response = await getSubscriptionPlanById(planId)
          if (response?.status === 200 && response?.data) {
            return [planId, response.data]
          }
        } catch (error) {
          console.error('Error fetching subscription plan for booking selector:', error)
        }
        return [planId, null]
      }),
    ).then((planEntries) => {
      if (!isMounted) return
      setSubscriptionPlansById((prev) => {
        const nextPlansById = { ...prev }
        planEntries.forEach(([planId, planData]) => {
          nextPlansById[planId] = planData
        })
        return nextPlansById
      })
    })

    return () => {
      isMounted = false
    }
  }, [linkedSubscriptionPlanIds, subscriptionPlansById])

  function getFeeLabelForEvent(eventType) {
    if (!eventType) return ''
    if (eventType?.free) return formatEventFeeLabel(eventType)

    const planId = eventType?.subscriptionPlanId || eventType?.pricingPlanId
    if (!planId) {
      return formatEventFeeLabel(eventType)
    }

    if (!Object.prototype.hasOwnProperty.call(subscriptionPlansById, planId)) {
      return ''
    }

    const linkedPlan = subscriptionPlansById[planId]
    return linkedPlan ? formatEventFeeLabel(eventType, linkedPlan) : ''
  }

  console.log({ inPersonBlock, videoBlock, emergencyBlock, followUpBlock, selectedEventTypeId })
  console.log('E Types 1:', eventTypesVisible)

  useEffect(() => {
    console.log({ defaultEventTypeData })

    if (defaultEventTypeData) {
      let eventTypesForOtherSessionsDropdown = [...(eventTypesVisible || [])]

      let defaultOrFirstInPersonEventData = inPersonBlock
      let defaultOrFirstVideoEventData = videoBlock

      if (defaultOrFirstInPersonEventData) {
        eventTypesForOtherSessionsDropdown = eventTypesForOtherSessionsDropdown?.filter(
          (item) => item?.uid !== defaultOrFirstInPersonEventData?.uid,
        )
      }
      if (defaultOrFirstVideoEventData) {
        eventTypesForOtherSessionsDropdown = eventTypesForOtherSessionsDropdown?.filter(
          (item) => item?.uid !== defaultOrFirstVideoEventData?.uid,
        )
      }
      if (emergencyBlock) {
        eventTypesForOtherSessionsDropdown = eventTypesForOtherSessionsDropdown?.filter(
          (item) => item?.uid !== emergencyBlock?.uid,
        )
      }
      if (followUpBlock) {
        eventTypesForOtherSessionsDropdown = eventTypesForOtherSessionsDropdown?.filter(
          (item) => item?.uid !== followUpBlock?.uid,
        )
      }
      setOtherOptionsArray(eventTypesForOtherSessionsDropdown)

      console.log({ eventTypesForOtherSessionsDropdown, eventTypesVisible })

      setChosenBlockId(
        getChosenBlocksBasedOnDefaultSelectedItem({
          defaultEmergencyEventData: emergencyBlock,
          defaultFollowUpEventData: followUpBlock,
          defaultInPersonEventData: inPersonBlock,
          defaultSelectedItem: defaultEventTypeData,
          defaultVideoEventData: videoBlock,
        }),
      )
    }
  }, [
    selectedVisitType,
    eventTypesVisible,
    clinicLocationId,
    mentorProfileData,
    defaultEventTypeData,
    inPersonBlock,
    videoBlock,
    emergencyBlock,
    followUpBlock,
  ])

  useEffect(() => {
    setSelectedEventTypeId(defaultEventTypeData?.uid)
    if (setSelectedVisitType) {
      setSelectedVisitType(defaultEventTypeData?.visitEventType || VISIT_EVENT_TYPES.regular)
    }
  }, [
    defaultEventTypeData?.uid,
    defaultEventTypeData?.visitEventType,
    setSelectedEventTypeId,
    setSelectedVisitType,
  ])

  console.log('E Types 2:', eventTypesVisible)

  if (!eventTypesVisible) {
    return <div style={{ color: 'red' }}>No events offered in this location by mentor</div>
  }
  if (Array.isArray(eventTypesVisible) && eventTypesVisible.length === 0) {
    return <div style={{ color: 'red' }}>No events offered in this location by mentor</div>
  }

  return (
    <div>
      <div className="d-flex gap-2">
        {inPersonBlock && (
          <BlockComponent
            selected={selectedEventTypeId === inPersonBlock?.uid}
            clickFunction={() => {
              setChosenBlockId(CHOSEN_BLOCK_IN_PERSON)
              setSelectedEventTypeId(inPersonBlock?.uid)
            }}
            text={'In Person'}
            text2={`${inPersonBlock?.durationInMins}m`}
            fee={getFeeLabelForEvent(inPersonBlock)}
            icon={<Chair />}
          />
        )}
        {videoBlock && (
          <BlockComponent
            selected={selectedEventTypeId === videoBlock?.uid}
            clickFunction={() => {
              setChosenBlockId(CHOSEN_BLOCK_VIDEO)
              setSelectedEventTypeId(videoBlock?.uid)
            }}
            text={'Online'}
            text2={`${videoBlock?.durationInMins}m`}
            fee={getFeeLabelForEvent(videoBlock)}
            icon={<VideoCameraFront />}
          />
        )}
        {emergencyBlock && (
          <BlockComponent
            selected={selectedEventTypeId === emergencyBlock?.uid}
            backgroundColor="#cf7f73"
            borderColor="#cf7f73"
            textColor="#cf7f73"
            clickFunction={() => {
              setChosenBlockId(CHOSEN_BLOCK_EMERGENCY_IN_PERSON)
              setSelectedEventTypeId(emergencyBlock?.uid)
            }}
            text={'Emergency'}
            text2={`${emergencyBlock?.durationInMins}m`}
            fee={getFeeLabelForEvent(emergencyBlock)}
            icon={
              <img
                src={getImageLink(SIREN_ICON_ID)}
                alt="emergency_icon"
                style={{ height: '25px', width: '25px' }}
              />
            }
          />
        )}
        {followUpBlock && (
          <BlockComponent
            selected={selectedEventTypeId === followUpBlock?.uid}
            clickFunction={() => {
              setChosenBlockId(CHOSEN_BLOCK_FOLLOW_UP_IN_PERSON)
              setSelectedEventTypeId(followUpBlock?.uid)
            }}
            text={'Follow Up'}
            text2={`${followUpBlock?.durationInMins}m`}
            fee={getFeeLabelForEvent(followUpBlock)}
            icon={<CalendarMonth sx={{ fontSize: '20px' }} />}
          />
        )}
        {Array.isArray(otherOptionsArray) && otherOptionsArray.length > 0 && (
          <BlockComponent
            selected={isOtherSelected}
            clickFunction={() => {
              setSelectedEventTypeId(otherOptionsArray?.[0]?.uid)
            }}
            text={'Other'}
            text2={'Sessions'}
          />
        )}
      </div>
      {isOtherSelected && (
        <>
          <div style={{ fontSize: '12px', marginTop: '16px' }}>Select session type:</div>
          <FormControl fullWidth>
            <Select
              labelId="select-event-type-label"
              id="select-event-type"
              value={selectedEventTypeId}
              label="Session Type"
              onChange={(e) => setSelectedEventTypeId(e.target.value)}
              sx={{ height: '32px', marginTop: '8px' }}
            >
              {otherOptionsArray?.map((eventType, eventTypeIndex) => {
                const feeLabel = getFeeLabelForEvent(eventType)
                return (
                  <MenuItem key={eventTypeIndex} value={eventType?.uid}>
                    {eventType?.title}
                    <span style={{ marginLeft: '12px' }}>
                      {'('}
                      {eventType?.durationInMins}
                      {' mins)'}
                    </span>
                    <span
                      style={{ marginLeft: '12px', display: 'inline-flex', alignItems: 'center' }}
                    >
                      {getMeetingSrcIcon(eventType?.meetingSrc)}
                    </span>
                    {feeLabel && (
                      <span style={{ marginLeft: '8px', fontSize: '12px', color: '#374151' }}>
                        {feeLabel}
                      </span>
                    )}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </>
      )}
    </div>
  )
}

const BlockComponent = ({
  selected,
  text,
  text2,
  fee,
  icon,
  backgroundColor = '#7450aa',
  borderColor = '#7450aa',
  textColor = '#7450aa',
  clickFunction,
}) => {
  return (
    <div
      style={{
        cursor: 'pointer',
        background: selected ? backgroundColor : '#fff',
        border: `1px solid ${borderColor}`,
        color: selected ? '#fff' : textColor,
        borderRadius: '4px',
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '75px',
      }}
      onClick={() => clickFunction()}
    >
      <div>{icon}</div>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ marginTop: '4px' }}
      >
        <div style={{ fontSize: '12px' }}>{text}</div>
        <div style={{ fontSize: '10px' }}>{text2}</div>
        {fee && (
          <div style={{ fontSize: '10px', fontWeight: 600, marginTop: '2px' }}>{fee}</div>
        )}
      </div>
    </div>
  )
}
